// This plugin depends entirely on videojs-contrib-hls implementation
// Specially on the hls object, which we use hls.representations

import VideoJsAdapter from "@javascripts/adapters/videojs_adapter";
import Switcher from "./switcher";

export default class Index {
  static register() {
    VideoJsAdapter.registerPlugin('bitrateSwitcher', this.init);
  }

  static init(options) {
    var adapter;

    adapter = new VideoJsAdapter();
    adapter._instance = this;
    return (new Index(adapter, options));
  }

  static initComponent(adapter){
    var videoJsComponentClass = VideoJsAdapter.getComponent('Component');
    var bitrateSwitcherClass = VideoJsAdapter.extend(videoJsComponentClass, {
      constructor: function(){
        videoJsComponentClass.call(this, adapter.instance());
      },
      createEl: function(){
        let el = document.createElement("button");
        el.className = "vjs-bitrate-switcher vjs-control vjs-button";
        return el;
      }
    });

    //#TODO: check if this pose problem if called multiple times (in case of multiple player)
    VideoJsAdapter.registerComponent("BitrateSwitcherComponent", bitrateSwitcherClass);
  }

  adapter(){
    return this._adapter;
  }

  constructor(adapter, options = {}){

    Index.initComponent(adapter);
    adapter.on("loadedmetadata", function(){
      let bitratesObject;
      if (adapter.hasDashObject()) {
        bitratesObject = adapter.dashObject();
      } else {
        bitratesObject = adapter.hlsObject();
      }
      Index.appendSwitcher(adapter.el(), bitratesObject, adapter, options);
    });

    this._adapter = adapter;
    this._options = options;
  }

  static appendSwitcher(el, bitratesObject, adapter, options){
    //why static: on loadedmetadata event, we lost the context of bitrateSwitcher, thus cannot use function like this.adapter()

    var switcher = new Switcher(bitratesObject, adapter, options);
    var component = el.querySelector(".vjs-bitrate-switcher");
    if (component) {
      component.onclick = function(){
        switcher.toggle();
      };
      component.appendChild(switcher.el());
    }
  }
}

Index.register();
